export function pad(num: number | string, size = 2) {
    num = num.toString();
    while (num.length < size) num = '0' + num;
    return num;
}
